import React from 'react';
import styled from 'styled-components';
import { PALE, SOFT_TOMATO } from '../../colors';

interface CategorySliderProps {
  categories: any[];
  onSelect: (id: string, name: string) => void;
}

const CategorySlider = ({
  categories,
  onSelect
}: CategorySliderProps) => {

  return (
    <ScrollContainer>
      {categories.map((category, index) => (
        <CategoryItem key={index}
          onClick={() => onSelect(category._id, category.name)}
        >
          {category.name.toUpperCase(0)}
        </CategoryItem>
      ))}
    </ScrollContainer>
  );
};

export default CategorySlider;


const ScrollContainer = styled.div`
  display: flex;
  overflow-x: auto;
  padding: 1rem 0;
  gap: 0.75rem;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* IE/Edge */
  
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;

const CategoryItem = styled.button`
  flex: 0 0 auto;
  padding: 0.5rem 1rem;
  background-color: ${PALE};
  border: none;
  border-radius: 999px;
  font-size: 0.9rem;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s ease;
  font-family: 'Poppins-Medium';
  font-size: 0.8rem;

  &:hover {
    background-color: ${SOFT_TOMATO};
    color: white;
  }
`;